import { render, staticRenderFns } from "./GroupNavigationItem.vue?vue&type=template&id=39ad550d&"
import script from "./GroupNavigationItem.vue?vue&type=script&lang=js&"
export * from "./GroupNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports